import { Colors, Lightning, Utils, Img } from '@lightningjs/sdk';
import { Theme, themeManager } from './ThemeManager';
import Router from '@lightningjs/sdk/src/Router';
import { Icon } from '../../data-display/Icon/Icon';

interface ColorField {
  key: keyof ColorValues;
  label: string;  
  placeholder: string;
}

interface ColorValues {
  background: string;
  button: string;
  paragraph: string;
  title: string;
  interaction: string;
  logoUrl?: string;
}

const COLOR_FIELDS: ColorField[] = [
  { key: 'background', label: 'Background color:', placeholder: '#FFFFFF' },  
  { key: 'button', label: 'Button color:', placeholder: '#FFFFFF' },          
  { key: 'paragraph', label: 'Paragraph text color:', placeholder: '#FFFFFF' }, 
  { key: 'title', label: 'Headings and Title color:', placeholder: '#FFFFFF' }, 
  { key: 'interaction', label: 'Interaction State Color:', placeholder: '#FFFFFF' }, 
];


export default class ThemeCustomizer extends Lightning.Component {
  // protected _focusable = true;
  static isOpen: boolean = false;
  private _callback: ((confirmed: boolean) => void) | null = null;
  private _colorValues: ColorValues = {
    background: '',
    button: '',
    paragraph: '',
    title: '',
    interaction: '',
  };

  private _logoUrl: string | null = null;
  private _focusIdx = 0;
  private _editing = false;
  private _editBuffer = '';

  static override _template() {
    return {
      rect: true,
      w: 465,
      h: 1900,
      color: 0xff1f1f1f,
      zIndex: 999,
      alpha: 0,
      visible: true,
      collision: true,
      enablePointer: true,
      Label: {
        x: 30,
        y: 30,
        text: {
          text: 'Customize your App',
          fontSize: 30,
          fontWeight: 'bold',
          fontFace: 'Regular',
          textColor: 0xffffffff,
        },
      },
      Form: {
        y: 90,
        x: 30,
        flex: { direction: 'column' },
        children: [
          ...COLOR_FIELDS.slice(0).map((f, i) => this._inputBlock(f.label, i)),
          {
            ref: 'LogoUpload',
            flexItem: { marginTop: 20 },
            flex: { direction: 'column' },
            children: [
              {
                flex: { direction: 'column' },
                children: [
                  {
                    text: {
                      text: 'Upload your logo:',
                      fontFace: "Secondary-Regular",
                      fontSize: 20,
                      textColor: 0xffffffff,
                    },
                  },
                  {
                    ref: 'UploadBoxWrapper',
                    w: 369,
                    h: 157,
                    y: 15,
                    rect: true,
                    color: 0xff1f1f1f,
                    children: [
                      ...this.generateDashedBorder(369, 157),
                      {
                        ref: 'UploadBox',
                        w: 369,
                        h: 157,
                        flex: { 
                          direction: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center'
                        },
                        children: [
                          {
                            type: Icon,
                            w: 32,
                            h: 32,
                            icon: 'upload',
                            iconWidth: 32,
                            iconHeight: 32,
                            flexItem: { marginBottom: 12 }
                          },
                          {
                            type: Lightning.Component,
                            rect: true,
                            w: 120,
                            h: 24,
                            color: 0xff9128b1,
                            shader: {
                              type: Lightning.shaders.RoundedRectangle,
                              radius: 10,
                            },
                            flex: {
                              direction: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                            },
                            children: [
                              {
                                text: {
                                  text: 'Browse',
                                  fontSize: 14,
                                  textColor: 0xffffffff,
                                  fontFace: "Regular", 
                                }
                              }
                            ]
                          },
                          {
                            type: Lightning.Component,
                            y: 10,
                            flex: {
                              direction: 'row',
                              alignItems: 'center',
                              justifyContent: 'center'
                            },
                            children: [
                              {
                                text: {
                                  text: 'Drop a file here',
                                  fontSize: 15,
                                  textColor: 0xff808080,
                                  fontFace: "Secondary-Regular",
                                },
                              }
                            ]
                          },
                        ],
                      },
                    ],
                  }
                  
                ],
              },
              {
                ref: 'FileDisplay',
                w: 320,
                h: 40,
                y: 20,
                color: 0xff2c2c2c,
                shader: {
                  type: Lightning.shaders.RoundedRectangle,
                  radius: 6,
                },
                visible: false,
                flex: {
                  direction: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingLeft: 10,
                  paddingRight: 10,
                },
                children: [
                  {
                    type: Lightning.Component,
                    flex: { direction: 'row', alignItems: 'center' },
                    ref: 'FileMetaRow',
                    children: [
                      {
                        type: Icon,
                        w: 20,
                        h: 20,
                        icon: 'image',
                        iconWidth: 20,
                        iconHeight: 20,
                      },
                      {
                        ref: 'FileName',
                        type: Lightning.Component,
                        x: 8,
                        text: {
                          text: 'Demo Tv logo.png',
                          fontFace: "Secondary-Regular",
                          fontSize: 18,
                          textColor: 0xffffffff,
                        },
                      },
                    ],
                  },
                  {
                    ref: 'RemoveFile',
                    type: Lightning.Component,
                    rect: true,
                    w: 30,
                    h: 30,
                    flex: {
                      direction: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                    },
                    text: {
                      text: '✕',
                      fontSize: 18,
                      textColor: 0xffff4444,
                    },
                  },
                ],
              }
              
            ],
          },
        ],
      },
      
      SaveButton: {
        y: 990,
        x: 30,
        type: Lightning.Component,
        rect: true,
        w: 369,
        h: 70,
        color: 0xff9128b1,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 12,
        },
        children: [
          {
            mount: 0.5,
            x: 184.5, 
            y: 35, 
            text: {
              text: 'Save Changes',
              fontSize: 20,
              fontFace: "Regular",
              textColor: 0xffffffff,
            }
          }
        ]
      },

      CloseButton: {
        type: Lightning.Component,
        x: 390,
        y: 35,
        text: {
          text: 'X',
          fontSize: 28,
          textColor: 0xffffffff,
        },
      },
    };
  }


  static generateDashedBorder(width: number, height: number) {
    const dashLength = 5;
    const gap = 3;
    const thickness = 2;
    const color = 0xffcccccc;
    const children = [];
  
    const horizontalCount = Math.floor((width + gap) / (dashLength + gap));
    const verticalCount = Math.floor((height + gap) / (dashLength + gap));
  
    // Top border
    for (let i = 0; i < horizontalCount; i++) {
      children.push({
        rect: true,
        x: i * (dashLength + gap),
        y: 0,
        w: dashLength,
        h: thickness,
        color
      });
    }
  
    // Bottom border
    for (let i = 0; i < horizontalCount; i++) {
      children.push({
        rect: true,
        x: i * (dashLength + gap),
        y: height - thickness,
        w: dashLength,
        h: thickness,
        color
      });
    }
  
    // Left border
    for (let i = 0; i < verticalCount; i++) {
      children.push({
        rect: true,
        x: 0,
        y: i * (dashLength + gap),
        w: thickness,
        h: dashLength,
        color
      });
    }
  
    // Right border
    for (let i = 0; i < verticalCount; i++) {
      children.push({
        rect: true,
        x: width - thickness,
        y: i * (dashLength + gap),
        w: thickness,
        h: dashLength,
        color
      });
    }
  
    return children;
  }
  
  
  private static _inputBlock(label: string, idx: number) {
    return {
      type: Lightning.Component,
      ref: 'InputBlock' + idx,
      flex: { direction: 'column', gap: 15, height: 91 },
      children: [
        {
          type: Lightning.Component,
          h: 40,
          rect: true,
          text: {
            text: label,
            fontSize: 19,
            fontWeight: 600,
            fontFace: "Secondary-Regular",
            textColor: 0xffffffff,
          },
        },
        {
          type: Lightning.Component,
          w: 300,
          h: 49,
          color: 0xff1f1f1f,
          ref: 'InputContainer' + idx,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
            stroke: 1,
            strokeColor: 0xff888888,
          },
          flex: {
            direction: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: 30,
          },
          children: [
            {
              ref: 'InputField' + idx,
              type: Lightning.Component,
              w: 300,
              h: 49,
              color: 0x00000000,
              flex: {
                direction: 'row',
                alignItems: 'center',
              },
              children: [
                {
                  type: Lightning.Component,
                  w: 300,
                  h: 49,
                  text: {
                    text: `E.g ${COLOR_FIELDS[idx]?.placeholder}` || '',
                    fontSize: 20,
                    fontFace: "Secondary-Regular",
                    lineHeight: 49, 
                    textAlign: 'left',
                    verticalAlign: 'middle', 
                    paddingLeft: 10,
                  },      
                  ref: 'InputText' + idx,
                },
                {
                  type: Lightning.Component,
                  ref: 'Cursor' + idx,
                  w: 2,
                  h: 30,
                  color: 0xffffffff,
                  alpha: 0,
                  visible: false,
                }
              ],
            },
            {
              ref: 'ColorBox' + idx,
              rect: true,
              x: 20,
              w: 49,
              h: 49,
              color: parseInt('0xff' + COLOR_FIELDS[idx]?.placeholder.replace('#', ''), 16),
              borderRadius: 2,
            },
          ],
        },
      ],
    };
  }

  override _construct() {
    window.addEventListener('logo-drop', (e: Event) => {
      const customEvent = e as CustomEvent;
      this._logoUrl = customEvent.detail;
      this._updateLogoDisplay();
    });
  }
  _onColorChange(color: string) {
    this._colorValues.background = color;
    this._updateFields();
  }

  open(callback: (confirmed: boolean) => void) {
    this._callback = callback;
    
    // Update the panel state
    ThemeCustomizer.isOpen = true;
    
    // Make sure the panel is visible before animating
    this.patch({
        visible: true,
        alpha: 1
    });
    
    // Force a redraw to ensure visibility
    if (this.stage) {
        this.stage.update();
    }
    
    // Move to starting position immediately to ensure it's visible
    this.patch({
        x: this.stage.w
    });
    
    // Slide in from right with animation
    setTimeout(() => {
        this.setSmooth("x", this.stage.w - 465, {
            duration: 0.3,
            timingFunction: "ease-out"
        });
        
        // Focus the background color input after animation starts
        setTimeout(() => {
            const menuItems = this.tag("Content");
            if (menuItems) {
                menuItems.focusBgColorInput();
            }
        }, 100);
    }, 50);
    
    this.signal("opened");
  }

  close() {
    // Update the panel state
    ThemeCustomizer.isOpen = false;
    
    // Slide out to right with animation
    this.setSmooth("x", this.stage.w, {
        duration: 0.3,
        timingFunction: "ease-in"
    });
    
    // Use a timeout to hide after animation completes
    setTimeout(() => {
        // Hide after animation completes
        this.patch({
            visible: false
        });
        
        if (this._callback) {
            this._callback(false);
            this._callback = null;
        }
    }, 350); // Slightly longer than animation duration
    
    this.signal("closed");
  }
  
  override _init() {
    this.tag('RemoveFile')?.on('txMouseDown', () => {
      this._logoUrl = null; // Clear the logo URL
      this._updateLogoDisplay();
      // After removal, move focus back to browse button
      this._focusIdx = COLOR_FIELDS.length;
      this._setFocusVisual(); 
      // Signal that logo was removed
      this.signal('logoRemoved');

    });

    this.tag('UploadBox')?.children[0]?.on('txMouseDown', () => this._handleBrowseClick());
  }

override _focus() {

  this._focusIdx = 0; // Start with first field focused
  this._setFocusVisual();
}

override _unfocus() {
  this._setFocusVisual(); // Reset visual state
}

_handleDrop(event: DragEvent) {
  event.preventDefault();
  const file = event.dataTransfer?.files?.[0];
  if (file && file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = () => {
      this._logoUrl = reader.result as string;
      this._updateLogoDisplay(); // Only update preview
    };
    reader.readAsDataURL(file);
  }
}

_handleBrowseClick() {
  // Create a file input element
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = 'image/*';
  fileInput.style.display = 'none';
  
  // Add event listener for file selection
  fileInput.addEventListener('change', (event) => {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this._logoUrl = reader.result as string;
        this._updateLogoDisplay();
      };
      reader.readAsDataURL(file);
    }
    
    // Clean up
    document.body.removeChild(fileInput);
  });

  // Add to document and trigger click
  document.body.appendChild(fileInput);
  fileInput.click();
}

_updateLogoDisplay() {
  const fileBox = this.tag('FileDisplay');
  const fileName = this.tag('LogoUpload').tag('FileDisplay').tag('FileMetaRow').tag('FileName')

  if (this._logoUrl) {
      fileBox.visible = true;
      
      // Default display name
      let displayName = 'Uploaded Logo';
      
      // Extract image type from base64 URL
      const mimeMatch = this._logoUrl.match(/^data:(image\/\w+);base64/);
      if (mimeMatch) {
          const imageType = mimeMatch[1]?.split('/')[1];
          displayName = `logo.${imageType}`;
      }

      fileName.text.text = displayName;
  } else {
      fileBox.visible = false;
      fileName.text.text = '';
  }
}

  override _handleBack() {
    if (this._editing) {
      this._editing = false;
      this._editBuffer = '';
      this._updateFields();
      return true;
    }

    if (this._focusIdx < COLOR_FIELDS.length) {
      const field = COLOR_FIELDS[this._focusIdx];
      if (field) {
        this._colorValues[field.key] = '';
        this._updateFields();
        return true;
      }
    }

    // Only close if not editing and not clearing a field
    this.close();
    this.signal('closed');
    return true;
  }
  

  override _getFocused() {
    if (this._focusIdx < COLOR_FIELDS.length) {
      return this.tag(`InputContainer${this._focusIdx}`) as Lightning.Component;
    } else if (this._focusIdx === COLOR_FIELDS.length) {
      return this.tag('UploadBox')?.children[0] as Lightning.Component;
    } else if (this._focusIdx === COLOR_FIELDS.length + 1) {
      if (this._logoUrl) {
        const removeFile = this.tag('FileDisplay')?.tag('RemoveFile');
        if (removeFile) {
          return removeFile as Lightning.Component;
        }
      }
      // Otherwise focus on save button
      return this.tag('SaveButton') as Lightning.Component;
    } else if (this._focusIdx === COLOR_FIELDS.length + 2) {
      return this.tag('SaveButton') as Lightning.Component;
    } else {
      return this.tag('CloseButton') as Lightning.Component;
    }
  }

  
  override _handleDown() {
    if (this._editing) {
      this._editing = false;
      this._editBuffer = '';
      this._updateFields();
    }
    if (this._focusIdx < COLOR_FIELDS.length + 3) { // +3 for UploadBox, RemoveFile/SaveButton, and CloseButton
      this._focusIdx++;
      this._setFocusVisual();
    }
  }
  
  override _handleUp() {
    if (this._editing) {
      this._editing = false;
      this._editBuffer = '';
      this._updateFields();
    }
    if (this._focusIdx > 0) {
      this._focusIdx--;
      this._setFocusVisual();
    }
  }
  

  override _handleEnter() {
    if (this._focusIdx < COLOR_FIELDS.length) {
        const field = COLOR_FIELDS[this._focusIdx];
        if (!field) return;
        
        if (this._editing) {
            if (this._isValidHexColor(this._editBuffer)) {
                this._colorValues[field.key] = this._editBuffer.startsWith('#')
                    ? this._editBuffer
                    : `#${this._editBuffer}`;
            }
            this._editing = false;
            this._updateFields();
        } else {
            this._editBuffer = this._colorValues[field.key] || '';
            this._editing = true;
            this._setEditBuffer();
        }
        return;
    }
 
    switch (this._focusIdx) {
        case COLOR_FIELDS.length:
            this._handleBrowseClick();
            break;
            
        case COLOR_FIELDS.length + 1:
            if (this._logoUrl) {
                this._logoUrl = null;
                this._updateLogoDisplay();
                this._focusIdx = COLOR_FIELDS.length;
                this._setFocusVisual();
                this.signal('logoRemoved');
            } else {
                this._handleSave();
            }
            break;
            
        case COLOR_FIELDS.length + 2:
            if (this._logoUrl) {
                this._handleSave();
            }
            else {
              this.close();
              this.signal('closed');
            }
            break;
            
        default:
            this.close();
            this.signal('closed');
    }
}
  override _handleKey(event: { key: string }) {
   
    const { key } = event;
    if (this._editing) {
      const fieldKey = COLOR_FIELDS[this._focusIdx]?.key;
  
      switch (key) {
        case 'Enter':
          if (this._isValidHexColor(this._editBuffer)) {
            if (fieldKey) {
              this._colorValues[fieldKey] = this._editBuffer.startsWith('#') 
                ? this._editBuffer 
                : `#${this._editBuffer}`;
            }
            this._editing = false;
            this._updateFields();
           
          }
          break;
          
        case 'Escape':
          this._editing = false;
          if (fieldKey) {
            this._editBuffer = this._colorValues[fieldKey] || '';
          }
          this._updateFields();
          break;
          
        case 'Backspace':
          this._editBuffer = this._editBuffer.slice(0, -1);
          this._setEditBuffer();
          break;
          
        default:
          // Only allow hex color characters
          if (/^[0-9a-fA-F#]$/.test(key) && this._editBuffer.length < 7) {
            // Don't allow multiple #
            if (key === '#' && this._editBuffer.includes('#')) {
              break;
            }
            
            // If adding first character and it's not #, prepend #
            if (this._editBuffer.length === 0 && key !== '#') {
              this._editBuffer = '#';
            }
            
            this._editBuffer += key;
            this._setEditBuffer();
          }
      }
    } else {
      switch (key) {
        case 'ArrowUp': this._handleUp(); break;
        case 'ArrowDown': this._handleDown(); break;
        case 'Enter': this._handleEnter(); break;
        case 'Back': this._handleBack(); break;
      }
    }
  }

  _updateFields() {
    const form = this.tag('Form');
    COLOR_FIELDS.forEach((f, i) => {
      const inputBlock = form.children[i];
      if (!inputBlock) return;
  
      const inputContainer = inputBlock.getByRef('InputContainer' + i);
      const inputText = inputContainer?.getByRef('InputField' + i)?.getByRef('InputText' + i);
      const colorBox = this._getColorBox(i);
      const currentValue = this._colorValues[f.key] || f.placeholder;
      
      if (inputText) {
        inputText.patch({
          text: {
            text: currentValue,
            textColor: this._focusIdx === i ? 0xffffffff : 0xffaaaaaa,
          }
        });
      }
  
      if (colorBox) {
        colorBox.patch({
          color: parseInt('0xff' + currentValue.replace('#', ''), 16)
        });
      }
  
      if (inputContainer) {
        inputContainer.patch({
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
            stroke: this._focusIdx === i ? 3 : 1,
            strokeColor: this._focusIdx === i ? 0xffffffff : 0xff888888,
          },
        });
      }
    });
  }
  _getInputField(idx: number) {
    return this.tag('Form')
               .tag(`InputBlock${idx}`)
               .tag(`InputContainer${idx}`)
               .tag(`InputField${idx}`);
  }

  _getColorBox(idx: number) {
    return this.tag('Form')
               .tag(`InputBlock${idx}`)
               .tag(`InputContainer${idx}`)
               .tag(`ColorBox${idx}`);
  }

  private _isValidHexColor(color: string): boolean {
    return /^#?([0-9A-F]{3}){1,2}$/i.test(color);
  }
  

  _setEditBuffer() {
    const inputField = this._getInputField(this._focusIdx);
    if (!inputField) return;
  
    const currentValue = this._editBuffer || '';
    const field = COLOR_FIELDS[this._focusIdx];
    const inputText = inputField.getByRef('InputText' + this._focusIdx);
    const cursor = inputField.getByRef('Cursor' + this._focusIdx);
    const colorBox = this._getColorBox(this._focusIdx);
  
    const isValid = this._isValidHexColor(currentValue) || currentValue.length === 0;
    const textColor = isValid ? 0xffffffff : 0xffff0000;
  
    if (inputText) {
      inputText.patch({
        text: {
          text: currentValue || field?.placeholder || '',
          textColor: textColor,
          fontSize: 20
        }
      });
    }
  
    // Update color box preview to match input
    if (colorBox) {
      const colorValue = currentValue || field?.placeholder || '#ffffff';
      colorBox.patch({
        color: parseInt('0xff' + colorValue.replace('#', ''), 16)
      });
    }
  
    if (cursor) {
      cursor.patch({
        visible: this._editing,
        alpha: this._editing ? 1 : 0,
        x: inputText.texture.w + 5
      });
    }
  }
  _setFocusVisual() {
    COLOR_FIELDS.forEach((_, i) => {
      const inputBlock = this.tag('Form').getByRef('InputBlock' + i);
      if (!inputBlock) return;
  
      const container = inputBlock.getByRef('InputContainer' + i);
      if (container) {
        const isFocused = this._focusIdx === i;
        container.patch({
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 6,
            stroke: isFocused ? 3 : 1,
            strokeColor: isFocused ? 0xffffffff : 0xff888888,
          },
        });
      }
    });
  
    // Update UploadBox focus state
    const uploadBox = this.tag('UploadBox');
    const browseButton = uploadBox?.children[1]; // The Browse button is the second child
    if (browseButton) {
      const isFocused = this._focusIdx === COLOR_FIELDS.length;
      browseButton.patch({
        color: isFocused ? 0xff00aaff : 0xff9128b1,
      });
    }
  
    // Update Remove button focus state
    const removeButton = this.tag('FileDisplay')?.tag('RemoveFile');
    if (removeButton) {
      const isFocused = this._focusIdx === COLOR_FIELDS.length + 1 && this._logoUrl;
      removeButton.patch({
        text: {
          textColor: isFocused ? 0xff00aaff : 0xffff4444,
          fontSize: isFocused ? 24 : 20,
        },
      });
    }
  
    // Save button
    const saveButton = this.tag('SaveButton');
    if (saveButton) {
      const isFocused = this._focusIdx === (this._logoUrl ? COLOR_FIELDS.length + 2 : COLOR_FIELDS.length + 1);
      saveButton.patch({
        color: isFocused ? 0xff00aaff : 0xff9128b1,
      });
    }
  
    // Close button
    const closeButton = this.tag('CloseButton');
    if (closeButton) {
      const isFocused = this._focusIdx === (this._logoUrl ? COLOR_FIELDS.length + 3 : COLOR_FIELDS.length + 2);
      closeButton.patch({
        text: {
          textColor: isFocused ? 0xff00aaff : 0xffffffff,
        },
      });
    }
  }
  
  _handleSave() {
    const allColorsValid = COLOR_FIELDS.every(field =>
      this._isValidHexColor(this._colorValues[field.key] || field.placeholder)
    );
  
    if (!allColorsValid) return;
  
    const hexToARGB = (hex: string): number | null => {
      hex = hex.replace('#', '');
      
      if (hex.length === 6) {
        return parseInt('0xff' + hex, 16);
      }
      return null;
    };
  
    const updatedTheme: Theme = {
      background: hexToARGB(this._colorValues.background) ?? undefined,
      button: hexToARGB( this._colorValues.button) ?? undefined,  
      paragraph: hexToARGB( this._colorValues.paragraph) ?? undefined,
      title: hexToARGB( this._colorValues.title) ?? undefined,
      interaction: hexToARGB( this._colorValues.interaction) ?? undefined,
      logoUrl: this._logoUrl ?? undefined,
    };

  
    themeManager.setTheme(updatedTheme);
    this.close();
    Router.focusPage();
  }
  
}
